"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _types = require("./types");
var _utils = require("../../utils");
function setAttendeeTile(tileState) {
  return (0, _utils.actionCreator)(_types.BROADCAST_SET_ATTENDEE_TILE, tileState);
}
var _default = exports["default"] = setAttendeeTile;